import axios from 'axios'
export const API_URL = 'https://api.theflightpost.com/api'
export const ROOT_URL = 'https://theflightpost.com'

export const errorHandler = (dispatch, error, type) => {

	let errorMessage = error.response ? error.response.data : error

	dispatch({
		type,
		payload: errorMessage,
	})
}

export const postData = (url, data, isAuthReq, action, errorType) => (dispatch, getState) => {

	const requestUrl = API_URL + url
	let headers = {}

	if (isAuthReq) {
		let token = getState().auth.token
		let authorization = "Bearer " + token
		headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	}

	axios.post(requestUrl, data, headers)
	.then((response) => {
		dispatch({
			type: action,
			payload: response.data,
		})
	})
	.catch((error) => {
		console.log(error)
		//errorHandler(dispatch, error.response, errorType)
	})
}



// WEBPACK FOOTER //
// ./src/actions/index.js